import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'epay-faq',
  templateUrl: './faq.component.html',
})
export class FaqComponent implements OnInit {
  pagetitle = 'FAQs';

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.navigate(['/ncpFAQ']);
  }

}
